export const extractJson = (key) => {
  return key?.internal?.content ? JSON.parse(key?.internal?.content) : key
}
